<template>
  <span>
    <v-dialog v-model="headersVersionChanged" max-width="350">
      <v-card>
        <v-card-title class="headline">Уведомление</v-card-title>
        <v-card-text>
          <v-container>
          <p>Настройки таблицы были сброшены в связи с обновлением системы.</p>
        </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="headersVersionChanged = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout
      v-if="loading"
      justify-center
      align-center
      class="loading-indicator"
    >
      <v-progress-circular
        indeterminate
        :size="70"
        :width="7"
      />
    </v-layout>
    <document-request-details
        v-if="editing"
        :data="selectedItem"
        @close="close">
    </document-request-details>
    <v-card
      v-show="!firstLoading && !editing"
      class="main-card"
    >
      <v-card-title class="action-head">
        <v-row
                no-gutters
        >
          <v-col cols="5">
            <v-row class="mb-3">
              <v-col cols="2">
                <h6>Статус:</h6>
              </v-col>
              <v-col cols="10">
                <v-item-group multiple>
                  <v-item
                          v-for="(status, index) in statuses"
                          :key="index"
                          v-slot:default="{ active, toggle }">
                    <v-chip
                            active-class="blue--text"
                            :input-value="active"
                            @click="addToStatusFilter(status, toggle)">
                      {{ status.doc_status_name }}
                    </v-chip>
                  </v-item>
                </v-item-group>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2">
            <v-switch v-model="isArchived" label="Архивные"></v-switch>
          </v-col>
          <v-col cols="5">
            <v-dialog v-model="tableColumnsDialog" max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                        text
                        v-bind="attrs"
                        v-on="on"
                        class="mt-3"
                >
                  Выбрать колонки таблицы
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="headline">Выбор колонок для отображения в таблице</v-card-title>
                <v-card-text>
                  <v-container>
                  <v-row>
                    <v-col cols="6" sm="4" v-for="header in headers" v-bind:key="header.value">
                      <v-checkbox
                              class="pt-0 mt-0 pl-2"
                              v-model="header.visible"
                              hide-details
                              :label="header.text"
                      />
                    </v-col>
                  </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="tableColumnsDialog = false">Ok</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="slctHeaders"
        :items="documents"
        :options.sync="options"
        :server-items-length="serverItemsLength"
        fixed-header
        no-data-text="Нет данных для отображения"
        :footer-props="{
          itemsPerPageText: 'Число документов на странице',
          itemsPerPageOptions: [25, 50]
        }"
        dense
      >
        <template v-slot:item="{ item }">
          <tr class="link-row">
            <td  @click="getDetails(item)" v-if="isShowHeaderData('request_number')">
              {{ item.request_number }}
            </td>
            <td @click="getDetails(item)" v-if="isShowHeaderData('request_date')">{{ item.created_at | moment("DD/MM/YYYY") }}</td>
            <td @click="getDetails(item)" v-if="isShowHeaderData('expired_date')">{{ item.expired_date | moment("DD/MM/YYYY")}}</td>
            <td @click="getDetails(item)" v-if="isShowHeaderData('user_name')">{{ item.user.last_name }} {{ item.user.first_name }} {{ item.user.middle_name }}</td>
            <td @click="getDetails(item)" v-if="isShowHeaderData('customer_number')">{{ item.customer != null ? item.customer.customer_number : '' }}</td>
            <td @click="getDetails(item)" v-if="isShowHeaderData('type')">{{ item.type.name }}</td>
            <td @click="getDetails(item)" v-if="isShowHeaderData('status')">
              <v-chip :class="getStatusColor(item.status.id)">{{ item.status.name }}</v-chip>
            </td>
            <td @click="getDetails(item)" v-if="isShowHeaderData('assigned_user')">
              <template v-if="item.assigned_user ">
                {{ item.assigned_user.last_name }} {{ item.assigned_user.first_name }} {{ item.assigned_user.middle_name }}({{ item.assigned_user.username }})
              </template>
            </td>
            <td @click="getDetails(item)" v-if="isShowHeaderData('notifications')">
              <v-btn v-if="item.unread_comments > 0" title="Не прочитано сообщений" rounded class="v-size--small red white--text"
                     icon small>
                {{ item.unread_comments }}
              </v-btn>
              <v-btn v-if="item.new_files > 0" title="Новых файлов" rounded class="v-size--small orange white--text"
                     icon small>
                {{ item.new_files }}
              </v-btn>
            </td>
            <td v-if="isShowHeaderData('actions')">
              <v-btn v-if="isArchived" @click="removeFromArchive(item)" title="Убрать из архива" icon class="v-size--small" small>
                <v-icon>mdi-package-up</v-icon>
              </v-btn>
              <v-btn v-else @click="sendToArchive(item)" title="Отправить в архив" icon class="v-size--small" small>
                <v-icon>mdi-package-down</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </span>
</template>

<script>
import DocumentRequestDetails from './DocumentRequestDetails'
const HEADERS_VERSION = '1'
export default {
  name: 'DocumentsRequests',
  components: {
    DocumentRequestDetails
  },
  data () {
    return {
      search: '',
      documents: [],
      loading: true,
      firstLoading: true,
      options: { page: 1, itemsPerPage: 25 },
      serverItemsLength: 0,
      selectedItem: {},
      headers: [
        {
          text: 'Номер заявления',
          align: 'left',
          sortable: false,
          value: 'request_number',
          visible: true
        },
        {
          text: 'Дата подачи',
          align: 'left',
          sortable: false,
          value: 'request_date',
          visible: true
        },
        {
          text: 'Обработать до',
          align: 'left',
          sortable: false,
          value: 'expired_date',
          visible: true
        },
        {
          text: 'ФИО',
          align: 'right',
          sortable: false,
          value: 'user_name',
          visible: true
        },
        {
          text: 'Лицевой счёт',
          align: 'right',
          sortable: false,
          value: 'customer_number',
          visible: true
        },
        {
          text: 'Тип документа',
          align: 'left',
          sortable: false,
          value: 'type',
          visible: true
        },
        {
          text: 'Статус',
          align: 'left',
          sortable: false,
          value: 'status',
          visible: true
        },
        {
          text: 'Назначен на',
          align: 'right',
          sortable: false,
          value: 'assigned_user',
          visible: true
        },
        {
          text: 'Уведомления',
          align: 'right',
          sortable: false,
          value: 'notifications',
          visible: true
        },
        {
          text: 'Действия',
          align: 'right',
          sortable: false,
          value: 'actions',
          visible: true
        }
      ],
      statuses: [],
      filteredStatuses: [],
      adding: false,
      editing: false,
      selectedUserData: {},
      isArchived: false,
      tableColumnsDialog: false,
      headersVersionChanged: false,
      getTimer: ''
    }
  },
  watch: {
    options: {
      handler () {
        this.getDocumentsApiTimer()
      },
      deep: true
    },
    isArchived: {
      handler () {
        this.getDocumentsApiTimer()
      },
      deep: true
    },
    headers: {
      handler (newVal) {
        const parsed = JSON.stringify(Object(newVal))
        localStorage.setItem('documentsHeaders', parsed)
        localStorage.setItem('documentsHeadersVersion', HEADERS_VERSION)
      },
      deep: true
    }
  },
  computed: {
    slctHeaders: function () {
      return this.headers.filter(function (header) {
        return header.visible
      })
    }
  },
  mounted () {
    this.getDocumentsStatusApi()
    if (localStorage.getItem('documentsHeaders')) {
      if (localStorage.getItem('documentsHeadersVersion') === HEADERS_VERSION) {
        this.headers = JSON.parse(localStorage.getItem('documentsHeaders'))
      } else {
        this.headersVersionChanged = true
        localStorage.setItem('documentsHeadersVersion', HEADERS_VERSION)
        const parsed = JSON.stringify(Object(this.headers))
        localStorage.setItem('documentsHeaders', parsed)
      }
    }
  },
  methods: {
    getDocumentsApi () {
      this.loading = true
      const archived = this.isArchived ? 1 : 0
      this.axios.get(`/api/document_request/?status=${this.filteredStatuses}&archived=${archived}&per_page=${this.options.itemsPerPage}&page=${this.options.page}`
      ).then((response) => {
        this.documents = response.data.results
        this.serverItemsLength = response.data.count
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.firstLoading = false
        this.loading = false
      })
    },
    getDocumentsApiTimer () {
      clearTimeout(this.getTimer)
      this.getTimer = setTimeout(() => {
        this.getDocumentsApi()
      }, 100)
    },
    getDocumentsStatusApi () {
      this.axios.get(`/api/document_status/`).then((response) => {
        this.statuses = response.data.results
      }).catch((err) => {
        console.log(err)
      })
    },
    addToStatusFilter (status, toggle) {
      var index = this.filteredStatuses.indexOf(status.doc_status_id)
      if (index !== -1) {
        this.filteredStatuses.splice(index, 1)
      } else {
        this.filteredStatuses.push(status.doc_status_id)
      }
      this.getDocumentsApiTimer()
      toggle()
    },
    getDetails (item) {
      this.selectedItem = item
      this.editing = true
    },
    close () {
      this.editing = false
      this.getDocumentsApiTimer()
    },
    getStatusColor (statusId) {
      if (statusId === 2) {
        return 'orange'
      } else if (statusId === 3) {
        return 'green'
      } else if (statusId === 4) {
        return 'red'
      }
    },
    isShowHeaderData (headerName) {
      return this.slctHeaders.findIndex(el => el.value === headerName) > -1
    },
    sendToArchive (item) {
      if (confirm('Вы действительно хотите отправить документ в архив?')) {
        this.axios.post(`/api/document_request/${item.doc_request_id}/archive/`).then(() => {
          this.getDocumentsApiTimer()
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    removeFromArchive (item) {
      this.axios.post(`/api/document_request/${item.doc_request_id}/unarchive/`).then(() => {
        this.getDocumentsApiTimer()
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .action-head {
    width: 1100px;
  }
  .v-input__append-inner {
    cursor: pointer;
  }
  .v-card.main-card {
    position: unset;
    .v-data-table {
      position: absolute;
      height: calc(100% - 88px);
      right: 0;
      left: 0;
    }
    .v-data-table__wrapper {
      max-height: calc(100% - 59px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/documents-requests/DocumentsRequests.vue